var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogoMd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0007 6.2623L2.95472 2.01778C2.18556 1.69281 1.33398 2.25747 1.33398 3.09246V21.1663C1.33398 21.8107 1.85632 22.333 2.50065 22.333H23.5006C24.145 22.333 24.6673 21.8107 24.6673 21.1663V7.0359C24.6673 6.56703 24.3866 6.14371 23.9547 5.96122L14.6214 2.01778C13.8522 1.69281 13.0007 2.25747 13.0007 3.09247V6.2623ZM13.0007 6.2623V9.96305M5.22287 17.083H7.16732M9.11176 17.083H11.0562",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.86667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoMd);
export default __webpack_public_path__ + "static/media/company-logo-md.fcaa536ef3c472f03b99105febb163cb.svg";
export { ForwardRef as ReactComponent };